import React from 'react';
import SimpleTable from 'components/SimpleTable';
import PayoutTable from 'components/PayoutTable';
import 'assets/styles/winnings-status.scss';

const WinningsStatus = ({ roundsData, payTableData }) => {
    let wrapperClass = '';

    if (payTableData.length > 4) {
        wrapperClass = 'thirty'
    }

    return <div className={`winnings-status ${wrapperClass}`}>
        <PayoutTable payTableData={payTableData} />
        <SimpleTable separator title="Results" data={roundsData.filter(r => !r.dummy)} heading1="Round" heading2="Hits" />
    </div>;
};

WinningsStatus.defaultProps = {
    roundsData: [],
};

export default WinningsStatus;